import image1 from "../Assets/Images/image1.jpg";
import image2 from "../Assets/Images/image2.jpg";
import image3 from "../Assets/Images/image3.jpg";
import image4 from "../Assets/Images/image4.jpg";
import image5 from "../Assets/Images/image5.jpg";
import image6 from "../Assets/Images/image6.jpg";
import image7 from "../Assets/Images/image7.jpg";
import image8 from "../Assets/Images/image8.jpg";

const properties = [
  {
    id: 1,
    title: "Modern Villa in Gisozi",
    image: image1,
    images: [image1, image2, image3],
    price: 185000,
    location: "Gisozi",
    bedrooms: 5,
    bathrooms: 3,
    parking: 2,
    area: 423,
    type: "Villa",
    status: "For Sale",
    featured: true,
    description:
      "This stunning modern villa in Gisozi offers luxurious living with panoramic views of the city. Featuring an open-plan living area, gourmet kitchen with premium appliances, and a spacious master suite with a walk-in closet. The property includes a private garden, swimming pool, and a two-car garage.",
    amenities: [
      "Swimming Pool",
      "Garden",
      "Security System",
      "Solar Panels",
      "Smart Home",
      "Gym",
    ],
    agent: {
      name: "Jean Baptiste",
      phone: "+250799000000",
      email: "jean@homediscovery.rw",
    },
    yearBuilt: 2023,
    dateAdded: "2026-04-10",
  },
  {
    id: 2,
    title: "Elegant Apartment in Nyarutarama",
    image: image2,
    images: [image2, image4, image5],
    price: 120000,
    location: "Nyarutarama",
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 210,
    type: "Apartment",
    status: "For Sale",
    featured: true,
    description:
      "A beautifully designed apartment in the heart of Nyarutarama. This property features floor-to-ceiling windows, a modern kitchen, and a spacious balcony overlooking the hills. Perfect for professionals and small families seeking comfort and convenience.",
    amenities: [
      "Balcony",
      "Elevator",
      "Security System",
      "Parking Garage",
      "Gym",
    ],
    agent: {
      name: "Marie Claire",
      phone: "+250799000000",
      email: "marie@homediscovery.rw",
    },
    yearBuilt: 2024,
    dateAdded: "2026-04-08",
  },
  {
    id: 3,
    title: "Cozy Bungalow in Gacuriro",
    image: image3,
    images: [image3, image1, image6],
    price: 95000,
    location: "Gacuriro",
    bedrooms: 4,
    bathrooms: 2,
    parking: 1,
    area: 320,
    type: "Bungalow",
    status: "For Sale",
    featured: false,
    description:
      "A charming bungalow nestled in the quiet neighborhood of Gacuriro. Features a spacious living room, traditional kitchen, and a well-maintained garden. This home is perfect for families looking for a peaceful retreat.",
    amenities: ["Garden", "Security System", "Water Tank", "Servants Quarter"],
    agent: {
      name: "Patrick Mugabo",
      phone: "+250799000000",
      email: "patrick@homediscovery.rw",
    },
    yearBuilt: 2021,
    dateAdded: "2026-04-05",
  },
  {
    id: 4,
    title: "Luxury Penthouse in Kiyovu",
    image: image4,
    images: [image4, image7, image8],
    price: 320000,
    location: "Kiyovu",
    bedrooms: 4,
    bathrooms: 4,
    parking: 2,
    area: 500,
    type: "Penthouse",
    status: "For Sale",
    featured: true,
    description:
      "Experience the pinnacle of luxury living in this magnificent penthouse in Kiyovu. Features a rooftop terrace with 360° views, private elevator access, Italian marble flooring, and a chef's kitchen. The ultimate urban retreat.",
    amenities: [
      "Rooftop Terrace",
      "Private Elevator",
      "Smart Home",
      "Wine Cellar",
      "Home Theater",
      "Jacuzzi",
    ],
    agent: {
      name: "Jean Baptiste",
      phone: "+250799000000",
      email: "jean@homediscovery.rw",
    },
    yearBuilt: 2025,
    dateAdded: "2026-04-12",
  },
  {
    id: 5,
    title: "Family Home in Kimihurura",
    image: image5,
    images: [image5, image2, image3],
    price: 145000,
    location: "Kimihurura",
    bedrooms: 5,
    bathrooms: 3,
    parking: 2,
    area: 380,
    type: "House",
    status: "For Sale",
    featured: false,
    description:
      "A spacious family home in the desirable Kimihurura neighborhood. Features a large backyard, modern open-plan living areas, and proximity to international schools and shopping centers.",
    amenities: [
      "Garden",
      "Security System",
      "Solar Panels",
      "Water Tank",
      "Servants Quarter",
    ],
    agent: {
      name: "Marie Claire",
      phone: "+250799000000",
      email: "marie@homediscovery.rw",
    },
    yearBuilt: 2022,
    dateAdded: "2026-04-01",
  },
  {
    id: 6,
    title: "Studio Apartment in Remera",
    image: image6,
    images: [image6, image1, image4],
    price: 55000,
    location: "Remera",
    bedrooms: 1,
    bathrooms: 1,
    parking: 1,
    area: 85,
    type: "Apartment",
    status: "For Rent",
    featured: false,
    description:
      "A modern studio apartment in vibrant Remera, perfect for young professionals. Features an open-concept layout, built-in storage, and proximity to restaurants, shops, and public transport.",
    amenities: ["Security System", "Parking", "Laundry Room", "Internet"],
    agent: {
      name: "Patrick Mugabo",
      phone: "+250799000000",
      email: "patrick@homediscovery.rw",
    },
    yearBuilt: 2024,
    dateAdded: "2026-03-28",
  },
  {
    id: 7,
    title: "Countryside Retreat in Nyamirambo",
    image: image7,
    images: [image7, image5, image8],
    price: 78000,
    location: "Nyamirambo",
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 260,
    type: "House",
    status: "For Sale",
    featured: false,
    description:
      "A peaceful retreat in the culturally rich Nyamirambo area. This home blends traditional charm with modern amenities, featuring a cozy fireplace, herb garden, and stunning sunset views.",
    amenities: ["Garden", "Fireplace", "Water Tank", "Security System"],
    agent: {
      name: "Jean Baptiste",
      phone: "+250799000000",
      email: "jean@homediscovery.rw",
    },
    yearBuilt: 2020,
    dateAdded: "2026-03-20",
  },
  {
    id: 8,
    title: "Executive Townhouse in Kibagabaga",
    image: image8,
    images: [image8, image2, image6],
    price: 210000,
    location: "Kibagabaga",
    bedrooms: 4,
    bathrooms: 3,
    parking: 2,
    area: 350,
    type: "Townhouse",
    status: "For Sale",
    featured: true,
    description:
      "An executive townhouse in the prestigious Kibagabaga area. Features modern architecture, high ceilings, a gourmet kitchen, and a private courtyard. Close to hospitals, schools, and shopping.",
    amenities: [
      "Courtyard",
      "Security System",
      "Smart Home",
      "Solar Panels",
      "Gym",
    ],
    agent: {
      name: "Marie Claire",
      phone: "+250799000000",
      email: "marie@homediscovery.rw",
    },
    yearBuilt: 2024,
    dateAdded: "2026-04-11",
  },
  {
    id: 9,
    title: "Budget-Friendly Home in Kicukiro",
    image: image1,
    images: [image1, image3, image5],
    price: 62000,
    location: "Kicukiro",
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 200,
    type: "House",
    status: "For Sale",
    featured: false,
    description:
      "An affordable family home in the growing Kicukiro district. Features a practical layout, small garden, and easy access to main roads and public amenities.",
    amenities: ["Garden", "Water Tank", "Security Wall"],
    agent: {
      name: "Patrick Mugabo",
      phone: "+250799000000",
      email: "patrick@homediscovery.rw",
    },
    yearBuilt: 2019,
    dateAdded: "2026-03-15",
  },
  {
    id: 10,
    title: "Modern Duplex in Nyarutarama",
    image: image4,
    images: [image4, image6, image8],
    price: 275000,
    location: "Nyarutarama",
    bedrooms: 6,
    bathrooms: 4,
    parking: 3,
    area: 520,
    type: "Duplex",
    status: "For Sale",
    featured: true,
    description:
      "A magnificent duplex in Nyarutarama with stunning hillside views. This property offers two levels of luxurious living, a private infinity pool, landscaped gardens, and a state-of-the-art security system.",
    amenities: [
      "Infinity Pool",
      "Landscaped Garden",
      "Security System",
      "Smart Home",
      "Home Office",
      "Gym",
      "Sauna",
    ],
    agent: {
      name: "Jean Baptiste",
      phone: "+250799000000",
      email: "jean@homediscovery.rw",
    },
    yearBuilt: 2025,
    dateAdded: "2026-04-13",
  },
  {
    id: 11,
    title: "Commercial Space in CBD",
    image: image7,
    images: [image7, image2, image4],
    price: 450000,
    location: "Kiyovu",
    bedrooms: 0,
    bathrooms: 4,
    parking: 10,
    area: 800,
    type: "Commercial",
    status: "For Sale",
    featured: false,
    description:
      "Prime commercial real estate in Kigali's central business district. This modern office space features open-plan offices, conference rooms, and underground parking. Ideal for corporate headquarters.",
    amenities: [
      "Elevator",
      "Conference Rooms",
      "Underground Parking",
      "Generator",
      "Security",
      "Internet",
    ],
    agent: {
      name: "Marie Claire",
      phone: "+250799000000",
      email: "marie@homediscovery.rw",
    },
    yearBuilt: 2025,
    dateAdded: "2026-04-09",
  },
  {
    id: 12,
    title: "Charming Cottage in Kacyiru",
    image: image3,
    images: [image3, image5, image7],
    price: 88000,
    location: "Kacyiru",
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    area: 150,
    type: "Cottage",
    status: "For Rent",
    featured: false,
    description:
      "A charming cottage in quiet Kacyiru, perfect for couples or singles. Features a cozy interior, beautiful flower garden, and walking distance to shops and restaurants.",
    amenities: ["Garden", "Security System", "Water Heater"],
    agent: {
      name: "Patrick Mugabo",
      phone: "+250799000000",
      email: "patrick@homediscovery.rw",
    },
    yearBuilt: 2018,
    dateAdded: "2026-03-25",
  },
];

export default properties;

export const locations = [
  "All Locations",
  "Gisozi",
  "Nyarutarama",
  "Gacuriro",
  "Kiyovu",
  "Kimihurura",
  "Remera",
  "Nyamirambo",
  "Kibagabaga",
  "Kicukiro",
  "Kacyiru",
];

export const propertyTypes = [
  "All Types",
  "Villa",
  "Apartment",
  "Bungalow",
  "Penthouse",
  "House",
  "Townhouse",
  "Duplex",
  "Commercial",
  "Cottage",
];

export const priceRanges = [
  { label: "Any Price", min: 0, max: Infinity },
  { label: "Under $80,000", min: 0, max: 80000 },
  { label: "$80,000 - $150,000", min: 80000, max: 150000 },
  { label: "$150,000 - $250,000", min: 150000, max: 250000 },
  { label: "$250,000 - $400,000", min: 250000, max: 400000 },
  { label: "Above $400,000", min: 400000, max: Infinity },
];

export const dashboardStats = {
  totalProperties: properties.length,
  totalForSale: properties.filter((p) => p.status === "For Sale").length,
  totalForRent: properties.filter((p) => p.status === "For Rent").length,
  avgPrice: Math.round(
    properties.reduce((sum, p) => sum + p.price, 0) / properties.length
  ),
  featuredCount: properties.filter((p) => p.featured).length,
  locationBreakdown: locations.slice(1).map((loc) => ({
    name: loc,
    count: properties.filter((p) => p.location === loc).length,
  })),
  typeBreakdown: propertyTypes.slice(1).map((type) => ({
    name: type,
    count: properties.filter((p) => p.type === type).length,
  })),
  recentlyAdded: [...properties]
    .sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded))
    .slice(0, 5),
};
